// Follow Horizon's actual selected media, including thumbnail, swipe and variant selection.
class TDPMediaCaptions extends HTMLElement {
  connectedCallback() {
    this.gallery = this.closest('media-gallery');
    this.gallery?.addEventListener('slideshow:select', this.onSelect);
    const active = this.gallery?.querySelector('slideshow-slide[aria-hidden="false"] .product-media');
    if (active) this.show(active.dataset.mediaId);
  }

  disconnectedCallback() {
    this.gallery?.removeEventListener('slideshow:select', this.onSelect);
  }

  onSelect = (event) => {
    if (event.target !== this.gallery?.querySelector('slideshow-component')) return;
    const media = event.detail?.slide?.querySelector('.product-media');
    this.show(media?.dataset.mediaId);
  };

  show(mediaId) {
    this.querySelectorAll('[data-caption-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.captionPanel !== String(mediaId);
    });
  }
}

if (!customElements.get('tdp-media-captions')) {
  customElements.define('tdp-media-captions', TDPMediaCaptions);
}

// Live naam in het bijschrift van voorbeeldbeelden: "Jouw tekst: …"
(() => {
  const update = () => {
    const field = document.querySelector('[name="properties[Naam / tekst]"]');
    const value = (field?.value || '').trim();
    document.querySelectorAll('.tdp-media-caption p + p').forEach((p) => {
      if (!p.dataset.base) p.dataset.base = p.textContent;
      p.textContent = value ? `Jouw tekst: ${value} · zie 'Jouw uitvoering'` : p.dataset.base;
      p.classList.toggle('tdp-live-text', Boolean(value));
    });
  };
  document.addEventListener('input', (e) => { if (e.target?.name === 'properties[Naam / tekst]') update(); });
  document.addEventListener('DOMContentLoaded', update);
  let pending = null;
  new MutationObserver(() => { clearTimeout(pending); pending = setTimeout(update, 150); }).observe(document.documentElement, { childList: true, subtree: true });
})();
